import { createIcon } from '@chakra-ui/react'

export const Shield = createIcon({
    displayName: 'Shield',
    viewBox: '4 10 24 24',
    d: 'M12 34C9.68333 33.4167 7.771 32.0873 6.263 30.012C4.75433 27.9373 4 25.6333 4 23.1V17L12 14L20 17V23.1C20 25.6333 19.246 27.9373 17.738 30.012C16.2293 32.0873 14.3167 33.4167 12 34ZM12 31.9C13.7333 31.35 15.1667 30.25 16.3 28.6C17.4333 26.95 18 25.1167 18 23.1V18.375L12 16.125L6 18.375V23.1C6 25.1167 6.56667 26.95 7.7 28.6C8.83333 30.25 10.2667 31.35 12 31.9Z',
})
